"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const nodes = [{
  id: "sea",
  name: "Seattle",
  top: "30%",
  left: "10%",
  delay: "50ms"
}, {
  id: "ny",
  name: "New York",
  top: "35%",
  left: "20%",
  delay: "100ms"
}, {
  id: "lon",
  name: "ISTANBUL",
  top: "25%",
  left: "45%",
  delay: "300ms"
}, {
  id: "ist",
  name: "BEIJING",
  top: "32%",
  left: "58%",
  delay: "500ms"
}];
const stats = [{
  label: "Collective Experience",
  value: "100+",
  suffix: "Years"
}, {
  label: "Global Reach",
  value: "6",
  suffix: "FMCG"
}];
export default function OurGlobalFootprint() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="our-global-footprint" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 border-y border-border/10">
      {}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-sm font-mono tracking-widest uppercase text-muted-foreground mb-4">
            The Careful Consulting
          </h2>
          <p className="text-3xl md:text-5xl font-serif font-light tracking-tight text-foreground max-w-3xl mx-auto leading-tight">Local U.S. Insight. Global Operating Experience.</p>
        </div>

        {}
        <div ref={ref} className="relative w-full max-w-5xl mx-auto aspect-[4/3] md:aspect-[2.5/1] rounded-3xl border border-border/20 bg-card/20 backdrop-blur-md overflow-hidden flex items-center justify-center shadow-2xl shadow-black/50">
          {}
          <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: "radial-gradient(circle at 2px 2px, var(--color-muted-foreground) 1px, transparent 0)",
          backgroundSize: "24px 24px",
          maskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
          WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)"
        }} />

          {}
          <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-30" preserveAspectRatio="none">
            <path d="M 20% 35% Q 32% 15% 45% 25% T 58% 32% T 85% 40%" fill="none" stroke="var(--color-primary)" strokeWidth="1" strokeDasharray="4 4" className={`transition-all duration-[2000ms] ease-out ${isVisible ? "opacity-100" : "opacity-0"}`} />
          </svg>

          {}
          {nodes.map((node, i) => <div key={node.id} data-index={i} className="absolute flex flex-col items-center -translate-x-1/2 -translate-y-1/2" style={{
          top: node.top,
          left: node.left
        }}>
              <div className={`relative flex items-center justify-center w-6 h-6 transition-all duration-1000 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-50"}`} style={{
            transitionDelay: node.delay
          }}>
                {}
                <span className="absolute inline-flex h-full w-full rounded-full bg-primary/40 animate-ping" />
                {}
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-foreground shadow-[0_0_10px_var(--color-primary-foreground)]" />
              </div>
              <span className={`mt-3 text-[10px] md:text-xs font-mono tracking-widest text-muted-foreground uppercase transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`} style={{
            transitionDelay: `calc(${node.delay} + 200ms)`
          }}>
                {node.name}
              </span>
            </div>)}
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8 mt-24 max-w-4xl mx-auto text-center">
          {stats.map((stat, i) => <div key={stat.label} data-index={i} className={`flex flex-col items-center justify-center p-6 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${800 + i * 200}ms`
        }}>
              
              
              
              
            </div>)}
        </div>
      </div>
    </section>;
}